<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>To my sister Meg, who never left me in my years of darkness.</p><br/>
<p style=" text-indent:0em;">You let me into your heart, and you kept me there, I love you Margaret.</p><br/>
<p style=" text-indent:0em;">For my kids Jeremy and Josephine and their mother Jessica.</p><br/>
<p style=" text-indent:0em;">The amount of grace, compassion, forgiveness and love you have bestowed upon me in my life, even when I was sick and suffering, fills my heart with love. Your mom brought you to all those rehabs and hospitals to bring a smile and hope, those visits kept me fighting. I love all of you with all of my heart.</p><br/>
<p style=" text-indent:0em;">Thank you for your Grace</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?709d2ea5